import React from 'react';

export const FloorPlanEditorToolbar = ({
  tool,
  setTool,
  roomPoints,
  setRoomPoints,
  showGrid,
  setShowGrid,
  selectedRoomType,
  setSelectedRoomType,
  walls,
  rooms,
  roomTypes,
  roomColors,
}) => {
  return (
    <div className="w-64 bg-white rounded-xl shadow-sm p-4 space-y-4 h-fit" data-testid="floorplan-editor-toolbar">
      <div>
        <h3 className="font-semibold text-gray-900 mb-3" data-testid="floorplan-editor-tools-title">Ferramentas</h3>
        <div className="grid grid-cols-2 gap-2">
          <button
            onClick={() => {
              setTool('wall');
              setRoomPoints([]);
            }}
            className={`p-3 rounded-lg text-center transition ${tool === 'wall' ? 'bg-blue-100 text-blue-700 border-2 border-blue-500' : 'bg-gray-100 hover:bg-gray-200'}`}
            data-testid="floorplan-editor-tool-wall-button"
          >
            <div className="text-2xl">📏</div>
            <div className="text-xs mt-1">Parede</div>
          </button>
          <button
            onClick={() => setTool('room')}
            className={`p-3 rounded-lg text-center transition ${tool === 'room' ? 'bg-blue-100 text-blue-700 border-2 border-blue-500' : 'bg-gray-100 hover:bg-gray-200'}`}
            data-testid="floorplan-editor-tool-room-button"
          >
            <div className="text-2xl">🏠</div>
            <div className="text-xs mt-1">Cômodo</div>
          </button>
          <button
            onClick={() => {
              setTool('delete');
              setRoomPoints([]);
            }}
            className={`p-3 rounded-lg text-center transition ${tool === 'delete' ? 'bg-red-100 text-red-700 border-2 border-red-500' : 'bg-gray-100 hover:bg-gray-200'}`}
            data-testid="floorplan-editor-tool-delete-button"
          >
            <div className="text-2xl">🗑️</div>
            <div className="text-xs mt-1">Apagar</div>
          </button>
          <button
            onClick={() => setShowGrid(!showGrid)}
            className={`p-3 rounded-lg text-center transition ${showGrid ? 'bg-green-100 text-green-700' : 'bg-gray-100 hover:bg-gray-200'}`}
            data-testid="floorplan-editor-tool-grid-button"
          >
            <div className="text-2xl">📐</div>
            <div className="text-xs mt-1">Grade</div>
          </button>
        </div>
      </div>

      {tool === 'room' && (
        <div data-testid="floorplan-editor-room-settings">
          <h3 className="font-semibold text-gray-900 mb-3">Tipo de Cômodo</h3>
          <select
            value={selectedRoomType}
            onChange={(event) => setSelectedRoomType(event.target.value)}
            className="w-full p-2 border rounded-lg"
            data-testid="floorplan-editor-room-type-select"
          >
            {roomTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
          <div className="w-full h-8 rounded mt-2 border" style={{ backgroundColor: roomColors[selectedRoomType] }} data-testid="floorplan-editor-room-color-preview" />
          {roomPoints.length > 0 && (
            <p className="text-sm text-gray-500 mt-2" data-testid="floorplan-editor-room-points-count">
              {roomPoints.length} pontos • Clique perto do primeiro para fechar
            </p>
          )}
        </div>
      )}

      <div>
        <h3 className="font-semibold text-gray-900 mb-2" data-testid="floorplan-editor-instructions-title">Instruções</h3>
        <ul className="text-sm text-gray-600 space-y-1" data-testid="floorplan-editor-instructions-list">
          <li>• <b>Parede:</b> Clique e arraste</li>
          <li>• <b>Cômodo:</b> Clique nos cantos</li>
          <li>• <b>Fechar cômodo:</b> Clique no primeiro ponto</li>
          <li>• <b>Escala:</b> 1 quadrado = 1m</li>
        </ul>
      </div>

      <div className="pt-4 border-t text-sm text-gray-600" data-testid="floorplan-editor-summary-stats">
        <p data-testid="floorplan-editor-walls-count">Paredes: {walls.length}</p>
        <p data-testid="floorplan-editor-rooms-count">Cômodos: {rooms.length}</p>
      </div>
    </div>
  );
};
